import { render, staticRenderFns } from "./AutomatchTheFollowing.vue?vue&type=template&id=001f2b9e&scoped=true"
import script from "./AutomatchTheFollowing.vue?vue&type=script&lang=js"
export * from "./AutomatchTheFollowing.vue?vue&type=script&lang=js"
import style0 from "./AutomatchTheFollowing.vue?vue&type=style&index=0&id=001f2b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001f2b9e",
  null
  
)

export default component.exports